import { render } from "./ImportStudy.vue?vue&type=template&id=09413dce&scoped=true"
import script from "./ImportStudy.js?vue&type=script&lang=js"
export * from "./ImportStudy.js?vue&type=script&lang=js"

import "./ImportStudy.vue?vue&type=style&index=0&id=09413dce&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09413dce"]])

export default __exports__